import { ShieldCheck } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/hooks/useLanguage";
import { immigrationContent } from "@/i18n/immigration-content";

const UVisa = () => {
  const { language } = useLanguage();
  const content = immigrationContent.uvisa[language];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        {content.sections.map((section, idx) => (
          <div key={idx} className="mb-8">
            <h2 className="text-3xl font-bold mb-6">{section.title}</h2>
            <p className="text-xl text-muted-foreground mb-6">{section.content}</p>
            {section.items && (
              <ul className="list-disc pl-6 mb-6">
                {section.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            )}
          </div>
        ))}

        <h3 className="text-2xl font-bold mb-6">
          {language === 'en' ? 'Frequently Asked Questions' : language === 'es' ? 'Preguntas Frecuentes' : 'Câu Hỏi Thường Gặp'}
        </h3>
        <Accordion type="single" collapsible className="w-full">
          {content.faq.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title={content.title}
      subtitle={content.subtitle}
      icon={<ShieldCheck className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default UVisa;
